import {
  SPECIAL_RATES,
  DATES,
  DESTINATION,
  ROOMS_AND_GUESTS,
  USE_POINTS,
  RESET,
  DESTINATION_HIDDEN_FIELDS,
} from '../constants/StoreConstants';

import {
  DestinationFieldType,
  RoomsAndGuestsFieldType,
  UsePointsFieldType,
  SpecialRatesFieldType,
  DatesFieldType,
  ActionType,
  DestinationHiddenFieldsType,
} from './store.types';

export const setDestination = (payload: DestinationFieldType): ActionType => ({
  type: DESTINATION,
  payload,
});

export const setDates = (payload: DatesFieldType): ActionType => ({
  type: DATES,
  payload,
});

export const setRoomsAndGuests = (payload: RoomsAndGuestsFieldType): ActionType => ({
  type: ROOMS_AND_GUESTS,
  payload,
});

export const setUsePoints = (payload: UsePointsFieldType): ActionType => ({
  type: USE_POINTS,
  payload,
});

export const setSpecialRates = (payload: SpecialRatesFieldType): ActionType => ({
  type: SPECIAL_RATES,
  payload,
});

export const resetForm = (): ActionType => ({
  type: RESET,
});

export const setDestinationHiddenFields = (payload: DestinationHiddenFieldsType): ActionType => ({
  type: DESTINATION_HIDDEN_FIELDS,
  payload,
});
